import {Routes} from '@angular/router';
import {authGuard} from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/profile/routes').then(r => r.ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'event',
    loadChildren: () => import('./features/event/routes').then(r => r.ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./features/auth/forgot-password/routes').then(r => r.ROUTES)
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./features/auth/signup/signup.component').then(c => c.SignupComponent)
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./features/auth/sign-in/sign-in.component').then(c => c.SignInComponent)
  },
  {
    path: 'pdf-view/:id',
    loadComponent: () => import('./features/profile/pdf-view/pdf-view.component').then(c => c.PdfViewComponent)
  },
  {path: '**', redirectTo: ''}
];
